const { v4: uuidv4 } = require('uuid');
const model = require('model/model');

const SESSION_INACTIVITY_TIMEOUT = 1000 * 60 * 60; // 1 hour

module.exports = {
	SESSION_INACTIVITY_TIMEOUT: SESSION_INACTIVITY_TIMEOUT,

	getId: function () {
		if (typeof model.get('sessionId') === 'undefined') {
			this.initialize();
		}

		let sessionId = model.get('sessionId');

		if (!sessionId) {
			return undefined;
		}

		var sessionIdTokens = sessionId.split('_');

		if (new Date().getTime() - sessionIdTokens[1] > SESSION_INACTIVITY_TIMEOUT) {
			model.remove('sessionId');

			return this.getId();
		} else {
			return sessionIdTokens[0];
		}
	},

	initialize: function () {
		model.set('sessionId', uuidv4() + '_' + new Date().getTime());
	}
};
